export const tabsLaraThemeConfig = {
  colorScheme: {
    light: {
      tablistBackground: "transparent",
      tablistBorderWidth: "0 0 1px 0",
      tablistBorderColor: "var(--p-gray-200)",
      tabpanelBackground: "transparent",
      tabpanelPadding: "0 0 0 0",
      navButtonShadow: "0px 0px 10px 5px rgba(255,255,255,0.6)",
      tab: {
        padding: "0 var(--spacing-4) 10px var(--spacing-4)",
        background: "transparent",
        hover: {
          background: "transparent",
          borderColor: "{primary.600}",
          color: "{primary.700}",
        },
        active: {
          background: "transparent",
          borderColor: "{primary.600}",
          color: "{primary.700}",
        },
        border: {
          width: "0 0 2px 0",
          color: "transparent",
        },
      },
    },
  },
  css: () => `
    .p-tablist-nav-button {
      width: 25px;
      height: 25px;
      border: 1px solid var(--p-gray-200);
      top: -50%;
      transform: translateY(50%);
    }
    .p-tablist-content {
      width: 0;
    }
    .p-tablist-viewport > .p-tablist-tab-list {
      border: 0;
      gap: var(--spacing-12);
    }
  `,
};
